import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/sprites/common-sprite.svg'


const _hoisted_1 = _imports_0 + '#info-icon'
const _hoisted_2 = _imports_0 + '#cross-icon'
const _hoisted_3 = _imports_0 + '#arrow-icon'
const _hoisted_4 = _imports_0 + '#down-arrow-icon'
const _hoisted_5 = {
  key: 0,
  class: "label"
}
const _hoisted_6 = {
  key: 0,
  class: "info",
  "tooltip-right": "Required information"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "items"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "icon"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { class: "placeholder" }
const _hoisted_13 = {
  key: 0,
  class: "display-placeholder"
}
const _hoisted_14 = {
  key: 1,
  class: "right-side"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "arrow"
}
const _hoisted_17 = { class: "list" }
const _hoisted_18 = {
  key: 0,
  class: "searchbar"
}
const _hoisted_19 = { class: "items" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "icon"
}
const _hoisted_22 = ["xlink:href"]
const _hoisted_23 = { class: "text" }
const _hoisted_24 = {
  key: 1,
  class: "code display-code"
}
const _hoisted_25 = {
  key: 2,
  class: "code"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "grup-name" }
const _hoisted_28 = { class: "sub-items" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "text" }
const _hoisted_31 = {
  key: 1,
  class: "description"
}
const _hoisted_32 = {
  key: 2,
  class: "input-errors"
}
const _hoisted_33 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_component = _resolveComponent("input-component")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { required: _ctx.required }])
  }, [
    (_ctx.label || _ctx.labelitems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", { class: "required" }, [
                  _createElementVNode("use", { "xlink:href": _hoisted_1 })
                ], -1)
              ])))
            : _createCommentVNode("", true),
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(_ctx.label), 1))
            : _createCommentVNode("", true),
          (_ctx.labelitems)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelitems, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: _normalizeClass(item.class),
                    onClick: ($event: any) => (_ctx.emitter(item))
                  }, _toDisplayString(item.text), 11, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("section", {
      onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
      onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.keyHelper && _ctx.keyHelper(...args))),
      class: _normalizeClass({ active: _ctx.isActive, error: _ctx.errors && _ctx.errors.length, disabled: _ctx.disabled, searchable: _ctx.searchable })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["selective", { focus: _ctx.isFocus, selected: _ctx.selectedItem }]),
        tabindex: "0",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
      }, [
        (_ctx.selectedItem && _ctx.selectedItem.icon)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [
              _createElementVNode("use", {
                "xlink:href": _ctx.iconset + _ctx.selectedItem.icon
              }, null, 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_12, [
          (_ctx.displayPlaceholder && _ctx.selectedItem)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                (_ctx.displayPlaceholder.left)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "left-side",
                      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTooltip($event, _ctx.displayPlaceholder.left)))
                    }, _toDisplayString(_ctx.displayPlaceholder.left), 33))
                  : _createCommentVNode("", true),
                (_ctx.displayPlaceholder.right)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.displayPlaceholder.right), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.selectedItem ? (_ctx.selectedItem.code ? _ctx.selectedItem.code : _ctx.selectedItem.name) :
            _ctx.placeholder), 1))
        ]),
        (_ctx.selectedItem && !_ctx.disabled && _ctx.removable)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 1,
              class: "cross",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeItem && _ctx.removeItem(...args)), ["stop"]))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("use", { "xlink:href": _hoisted_2 }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[8] || (_cache[8] = [
              _createElementVNode("use", { "xlink:href": _hoisted_3 }, null, -1)
            ])))
      ], 2),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.searchable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_input_component, {
                placeholder: "Search in list",
                value: _ctx.searchText,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event))
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", [item.class, { selected: _ctx.selectedItem && _ctx.selectedItem.key == item.key, hide: _ctx.isHide(item), disabled: item.disabled }]]),
              ref_for: true,
              ref: "listItem",
              key: index,
              onClick: ($event: any) => (_ctx.selectItem(item))
            }, [
              (item.icon)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [
                    _createElementVNode("use", {
                      "xlink:href": _ctx.iconset + item.icon
                    }, null, 8, _hoisted_22)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_23, _toDisplayString(item.name), 1),
              (_ctx.displayPlaceholder && item.code)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.code), 1))
                : (item.code)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(item.code) + ")", 1))
                  : _createCommentVNode("", true)
            ], 10, _hoisted_20))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grouplist, (group, name) => {
            return (_openBlock(), _createElementBlock("div", { key: name }, [
              _createElementVNode("h2", {
                class: _normalizeClass(["item title", { 'hoverable': group.show }]),
                onClick: ($event: any) => (_ctx.toggleDropdown(group))
              }, [
                _createElementVNode("span", _hoisted_27, _toDisplayString(name), 1),
                (group.show)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      class: _normalizeClass(["down-arrow", { rotate: group.state }])
                    }, _cache[9] || (_cache[9] = [
                      _createElementVNode("use", { "xlink:href": _hoisted_4 }, null, -1)
                    ]), 2))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_26),
              _withDirectives(_createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", [item.class, { selected: _ctx.selectedItem && _ctx.selectedItem.key == item.key, hide: _ctx.isHide(item), disabled: item.disabled }]]),
                    ref_for: true,
                    ref: "listItem",
                    key: index,
                    onClick: ($event: any) => (_ctx.selectItem(item))
                  }, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(item.name), 1)
                  ], 10, _hoisted_29))
                }), 128))
              ], 512), [
                [_vShow, group.state]
              ])
            ]))
          }), 128))
        ])
      ])
    ], 34)), [
      [_directive_click_away, _ctx.close]
    ]),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    (_ctx.errors && _ctx.errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: error.$uid
            }, [
              (error.$message != '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(error.$message), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}